import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Panel } from 'primereact/panel'
import { connect } from 'react-redux'

import {
  Btn,
  CustomDropdown,
  ImportExcelFile,
  Loading,
  OutlinedBtnPrimary,
  PageHeader,
  TextBtn,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as CarregamentoHttp from '../../../../services/api/https/deliveries/carregamento.http'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { parseToMysqlFormat } from '../../../../services/util/date.service'

function ImportacaoRoteiro({ history, dispatch, selectedTp }) {
  // Vars
  const {
    location: {
      state: { dataPrevista, periodo },
    },
  } = history
  const tiposArquivos = [
    { label: '1 - ANTIGO - Modelo de Roteiro Danone', value: 1 },
    { label: '2 - NOVO - Modelo de Roteiro Danone', value: 2 },
    { label: '3 - Modelo de Roteiro Geral', value: 3 },
    { label: '4 - Placas Previstas Para Carregamento ', value: 4 },
    { label: '5 - Modelo de Roteiro Geral com Sequencia de Entrega ', value: 5 },
    { label: '6 - Modelo de importação Transcol', value: 6 },
    { label: '7 - Entregas Por Embarcador', value: 7 },
  ]
  // Hooks
  const [tipoArquivoId, setTipoArquivoId] = useState(1)

  const [isLoading, setIsLoading] = useState(false)

  // Events
  const onExportarModeloClicked = () => {
    try {
      let columns = []
      switch (tipoArquivoId) {
        case 1:
          throw new Error('Modelo Não disponível para Download')
        case 2:
          columns[0] = [
            'Id da Rota',
            'Shipment',
            'CD/TP',
            'CNPJ',
            'Placa T2',
            'Codigo SAP',
            'Numero do Pedido',
            'Nota Fiscal',
          ]
          break
        case 3:
          columns[0] = ['identificador', 'empresa', 'placa', 'ordem_carregamento']
          break
        case 5:
          columns[0] = ['identificador', 'empresa', 'placa', 'sequencia de entrega']
          break
        case 6:
          columns[0] = [
            'Última saída de Armazém',
            'Placa',
            'Motorista',
            'Nro. Nota',
            'Nome Cliente',
            'Destinatário',
            'Cidade',
            'CTEs',
            'UF',
            'clientecnpj',
          ]
          break
        case 7:
          columns[0] = ['Placa', 'CNPJ Embarcador', 'Nota Fiscal']
          break
        default:
          throw new Error('Tipo de Arquivo Não Encontrado. Contate o suporte')
      }
      const tipoArquivoSelecionado = tiposArquivos.find(t => t.value === tipoArquivoId)
      const nome_arquivo = tipoArquivoSelecionado.label.toLowerCase().replace(' ', '_') + '.xlsx'
      gerarArquivoExcel('modelo', columns, nome_arquivo)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }
  const onFileImported = async fileContent => {
    try {
      setIsLoading(true)
      // Se for tipo 6 (Transcol) e múltiplos arquivos, fileContent será um array de arrays
      if (
        tipoArquivoId === 6 &&
        Array.isArray(fileContent[0]) &&
        Array.isArray(fileContent[0][0])
      ) {
        // Processar cada arquivo separadamente
        for (const singleFileContent of fileContent) {
          const fileContentWithouEmptyRows = singleFileContent.filter(r => r.length)
          await CarregamentoHttp.importarRoteiroEntrega(selectedTp, {
            data_prevista_entrega: parseToMysqlFormat(dataPrevista),
            info: fileContentWithouEmptyRows,
            tipo_arquivo_id: tipoArquivoId,
          })
        }
      } else {
        // Comportamento original para arquivo único
        const fileContentWithouEmptyRows = fileContent.filter(r => r.length)
        await CarregamentoHttp.importarRoteiroEntrega(selectedTp, {
          data_prevista_entrega: parseToMysqlFormat(dataPrevista),
          info: fileContentWithouEmptyRows,
          tipo_arquivo_id: tipoArquivoId,
        })
      }
      history.push('/main/entregas/enviar-veiculos')
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsLoading(false)
    }
  }

  const onBtnVoltar = () => history.goBack()

  const onTipoArquivoChange = tipoArquivo_id => setTipoArquivoId(tipoArquivo_id)

  const onUtilizarEmplacamentoPrevioClicked = async () => {
    try {
      setIsLoading(true)
      await CarregamentoHttp.carregarPelasPlacasPrevistas(selectedTp, dataPrevista, periodo)
      dispatch(showMessageBox('Operação realizada com sucesso', null))
      history.goBack()
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsLoading(false)
    }
  }
  // Helpers

  // Template

  // Render
  return (
    <div>
      <PageHeader>Importação do Roteiro de Entrega </PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel header={<TextBtn onClick={onBtnVoltar}>Voltar</TextBtn>}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <div className="p-grid">
              <div className="p-col-3">
                <CustomDropdown
                  value={tipoArquivoId}
                  label="Selecione o Modelo para Importação"
                  options={tiposArquivos}
                  onChange={onTipoArquivoChange}
                />
              </div>
              <div className="p-col-4" style={{ paddingTop: 33 }}>
                {tipoArquivoId !== 4 ? (
                  <>
                    <ImportExcelFile
                      abaName={null}
                      label="Importar"
                      classes="btnImportar"
                      onFileImported={onFileImported}
                      multiple={tipoArquivoId === 6}
                    />
                    <div style={{ display: 'inline-block', marginLeft: 15 }}>
                      <Btn onClick={onExportarModeloClicked}>Baixar Modelo</Btn>
                    </div>
                  </>
                ) : (
                  <OutlinedBtnPrimary
                    onClick={onUtilizarEmplacamentoPrevioClicked}
                    label={'Utilizar Placas Previstas Para Carregamento'}
                  />
                )}
              </div>
            </div>
          )}
        </Panel>
      </div>
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ImportacaoRoteiro))
